// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__16YIP","tab":"Tabs_tab__3GJvI","tabActive":"Tabs_tabActive__3C6bA"};